/**
 * NoteTagButton — toggleable tag pill for note tagging.
 * Supports color from managed list configuration.
 */

import { makeStyles } from '@fluentui/react-components';
import type { NoteTagOption } from './useNoteConfig';

const useStyles = makeStyles({
  tag: {
    padding: '2px 10px',
    borderRadius: '12px',
    border: '1px solid #c4a98a',
    backgroundColor: '#fff',
    fontSize: '11px',
    cursor: 'pointer',
    transitionProperty: 'all',
    transitionDuration: '0.1s',
  },
});

interface NoteTagButtonProps {
  tag: NoteTagOption;
  selected: boolean;
  onToggle: (tagValue: string) => void;
}

export function NoteTagButton({ tag, selected, onToggle }: NoteTagButtonProps) {
  const styles = useStyles();
  const color = tag.color || '#D6461D';

  return (
    <span
      className={styles.tag}
      style={selected
        ? { backgroundColor: color, color: '#fff', borderColor: color }
        : { color: color, borderColor: color + '60' }
      }
      onClick={() => onToggle(tag.value)}
    >
      {tag.label}
    </span>
  );
}
